enum ActivityCompletion {
  COMPLETE = "complete",
  INCOMPLETE = "incomplete",
}

export default ActivityCompletion;
